import {Button, Col, Form, Row, InputGroup} from "react-bootstrap";
import Back from "../layout/template/back";
import React, {useState} from "react";
import DateTimeUtils from "../../services/DateTimeUtils";
import ApiService from "../../services/ApiService";
import GenericErrorModal from "../modal/genericErrorModal";

const AdminEditCoupon = () => {

    const [couponValue, setCouponValue] = useState(0);
    const [valueType, setValueType] = useState("valore"); // 'valore' or 'percentuale'

    const [errorModal, setErrorModal] = useState({
        state: false,
        title: "",
        body: ""
    });

    const handleRadioChange = (e) => {
        setValueType(e.target.value);
    };

    const handleSaveCoupon = (e) => {
        e.preventDefault();

        let couponValueInt = parseInt(couponValue)
        let couponData = {
            validUntil: DateTimeUtils.addOneYearToCurrentDate(),
            cost: valueType === "valore" ? couponValueInt : 0,
            discount: valueType === "percentuale" ? couponValueInt: 0
        }

        ApiService.createCoupon(couponData).then(response => {
            setErrorModal({
                state: true,
                title: `Buono ${response.code} creato correttamente`,
                body: "Ok"
            })
        })
            .catch(error => setErrorModal({
                state: true,
                title: "Errore nella creazione del buono",
                body: "Ok"
            }))
    }

    const handleCloseErrorModal = () => setErrorModal({
        state: false,
        title: "",
        body: ""
    })

    return (
        <>
            <Row>
                <Col xs={12}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>
                    <Row className={'justify-content-between'}>
                        <Col>
                            <div className={'title-page-section mt-5 mb-5'}>
                                <h2 className={'title'}>Nuovo Coupon</h2>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Form>
                    <Col xs={12} lg={6}>

                        <div key={`inline-radio`} className="mb-3">
                            <Form.Check
                                inline
                                label="Valore"
                                name="value"
                                type="radio"
                                value="valore"
                                checked={valueType === "valore"}
                                onChange={handleRadioChange}
                                id={`value`}
                            />
                            <Form.Check
                                inline
                                label="Percentuale"
                                name="value"
                                type="radio"
                                value="percentuale"
                                checked={valueType === "percentuale"}
                                onChange={handleRadioChange}
                                id={`rate`}
                            />
                        </div>

                        <InputGroup className="mb-4">
                            <Form.Control
                                type="number"
                                min={0}
                                max={valueType === "percentuale" ? 100 : undefined}
                                onChange={(e) => setCouponValue(e.target.value)}
                                placeholder="Valore coupon"
                            />
                            <InputGroup.Text id="value-addon">
                                {valueType === "percentuale" ? "%" : "CHF"}
                            </InputGroup.Text>
                        </InputGroup>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Row className={'justify-content-end'}>
                            <Col xs={'auto'}>
                                <Button variant={'primary'}
                                        className={'mb-5 px-5 fw-bold text-uppercase'} disabled={couponValue === 0 } onClick={handleSaveCoupon}>Salva</Button>
                            </Col>
                        </Row>
                    </Col>
                </Form>
            </Row>

            <GenericErrorModal handleClose={handleCloseErrorModal} contentText={errorModal} showModal={errorModal.state}/>

        </>

    );
}

export default AdminEditCoupon;
